import { Router } from '@angular/router';
// import { NavController } from "@ionic/angular/index";
import { ContactUsPage, HelpURLs } from '../contact-us/contact-us.page';
import { Component, OnInit } from "@angular/core";
import { ClubFlightService } from '../../../providers/club-flight-service/club-flight-service';
import { Location } from '@angular/common';




/**
 * Created by Ashok on 29-03-2016.
 */
@Component({
  templateUrl: "settings.page.html",
  styleUrls: ['settings.page.scss'],
})
export class SettingsPage implements OnInit {
  helpURL: string;

  constructor(
    private Location: Location,
    private router: Router,
    private flightService: ClubFlightService
  ) {
  }

  ngOnInit() {

    // this.refreshHelpUrl();
  }

  refreshHelpUrl() {
    this.flightService.getHelp()
      .subscribe((helpURL: Array<HelpURLs>) => {
        if (helpURL && helpURL.length > 0) {
          // && helpURL.length > 0
          this.helpURL = helpURL[0].url
        }
        // else this.helpURL = 'http://portal.mygolf2u.com/document/help-contents/mobile/help_content.html'

      }, (error) => {

      }, () => {
      })

  }


  callHelpPage() {
    this.flightService.getHelp()
      .subscribe((helpURL: any) => {
        if (helpURL && helpURL.length > 0) {
          // && helpURL.length > 0
          this.helpURL = helpURL[0].url;

          window.open(this.helpURL, '_self');
        }
        // else this.helpURL = 'http://portal.mygolf2u.com/document/help-contents/mobile/help_content.html'

      }, (error) => {

      }, () => {
      })

    // if(this.helpURL) {
    //
    //     window.open(this.helpURL, '_self');
    // }
    // else {
    //     this.refreshHelpUrl();
    //     setTimeout(()=>{
    //         this.callHelpPage();
    //     }, 1000)
    // }
    // window.open('http://mygolf2u.com/document/help-contents/mobile/help_content.html', '_self');
  }
  gotopage(Pagename) {
    this.router.navigate([Pagename])
  }

  back() {
    this.Location.back();
  }

}
